import React, { useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'

interface IProps {
  socialLink: SocialLinkItem
  width: number
  height: number
  className?: string
}

export type SocialLinkItem = {
  platform: 'X' | 'Instagram' | 'Facebook' | 'Tiktok' | 'LinkedIn'
  link: string
  id?: string | null
}

const SocialMediaLink = ({ socialLink, width, height, className }: IProps) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleHover = (isHovering: boolean | ((prevState: boolean) => boolean)) => {
    setIsHovered(isHovering)
  }

  return (
    <Link
      href={socialLink.link}
      className="flex items-center relative xl:p-[10px] p-0 xl:right-[4px] right-0"
      target="_blank"
      aria-label={socialLink.platform}
      key={socialLink.id || socialLink.link}
    >
      <Image
        src={`/images/favicons/${socialLink.platform}${isHovered ? '-yellow' : ''}.svg`}
        alt={socialLink.platform}
        width={width}
        height={height}
        onMouseOver={() => handleHover(true)}
        onMouseLeave={() => handleHover(false)}
        className={className}
      />
    </Link>
  )
}

export default SocialMediaLink